import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { of, Observable } from 'rxjs';
import { catchError, mapTo, tap, map } from 'rxjs/operators';
// import * as moment from 'moment';
// import * as moment_tz from 'node_modules/moment-timezone';


@Injectable({ providedIn: 'root' })
export class GateWayService {
    constructor(private http: HttpClient) {
    }

    gatewayCallback(code): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GATEWAY_CALLBACK}?code=${code}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    verifyGWToken(token, state): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_VERIFY_TOKEN}`, {
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`, 'State': `${state}` }
        })
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }


    getADMDLoginURI(state): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_ADMD_LOGIN}?state=${state}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    devLogin(state, username?): Observable<any> {
        const query = username ? `?state=${state}&username=${encodeURIComponent(username)}` : `?state=${state}`;
        return this.http.get<any>(`${environment.API}${environment.URL_ADMD_DEV_LOGIN}${query}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    ADMDLogout(): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_ADMD_LOGOUT}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    queryORG(): Observable<any> {

        return this.http.get<any>(`${environment.API}${environment.URL_QUERY_ORG}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    updateSelectedOrg(data): Observable<any> {

        return this.http.post<any>(`${environment.API}${environment.URL_UPDATE_SELECTED_ORG}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    clearPlatformToken(): Observable<any> {

        return this.http.get<any>(`${environment.API}${environment.URL_CLEAR_PLATFORM_TOKEN}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    getChildOrgByName(name): Observable<any> {

        return this.http.get<any>(`${environment.API}${environment.URL_GET_CHILD_ORG_BY_NAME}?child_org_name=${name}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    createChildOrg(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_CREATE_CHILD_ORG}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    updateChildOrg(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_UPDATE_CHILD_ORG}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    deleteChildOrg(id): Observable<any> {
        return this.http.delete<any>(`${environment.API}${environment.URL_DELETE_CHILD_ORG}/${id}`,)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    getLocationByPosition(latlng:string): Observable<any> {
        return this.http.get<any>(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latlng}&sensor=false&key=${environment.GOOGLE_KEY}&language=th`,)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
}




